
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexLBGLVDD3H5usmdwhu8QjtwfNYLvIF5x22aQcHV_0ddgMeta } from "/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/pages/index.vue?macro=true";
import { default as indexlhtcc13UdALvOMqgKqCzdFhArHCvO7l0CA5Qjwpn_45tIMeta } from "/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/pages/cart/index.vue?macro=true";
import { default as indexETW761_fxZ_Mp535lkVUC1hGWuKFio2DI_45EcnFxurpwMeta } from "/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/pages/terms/index.vue?macro=true";
import { default as indexFDbD9kb95RTjipBM9OEMA0PW_45LO7vV6EfW5MBPrLAFMMeta } from "/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/pages/orders/index.vue?macro=true";
import { default as indexaLLxiHVenmXIl4KOqdN8_q_gaF5nIwlbiN08xFpcTRYMeta } from "/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/pages/product/index.vue?macro=true";
import { default as index2D9rsbfRcYtbM0r_45EHPTmylTxggdVvEzFq7mydeQBXMMeta } from "/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/pages/proposals/index.vue?macro=true";
import { default as indexDIEe1fCiNQjLZFpFdda26PvOAAnTgFVGp7Io0D520VcMeta } from "/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/pages/closed-kits/index.vue?macro=true";
import { default as indexggkCGE33pkXAcm1VSMSe0zPAYTWlJxXd4LXD7bjiy14Meta } from "/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/pages/custom-kits/index.vue?macro=true";
import { default as indexIlnCWmhsIVKLOby_45_bTvI7Q8BFKE6iH0fSPav6lWAhIMeta } from "/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/pages/spare-products/index.vue?macro=true";
import { default as indexChQZVKgwxg8qQ6n2FeVqQJdxhwJXiw1SuylndDQIVVUMeta } from "/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/pages/checkout/confirm/index.vue?macro=true";
import { default as indext02As8mdbm0ZOLQhYKU8hXTjRkIg_45j3AgnwHfruE5Q0Meta } from "/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/pages/checkout/payment/index.vue?macro=true";
import { default as indexwaV93NtXb4c2IuO7yiotjW4YRZ5q3pQK3MVBii2AxPEMeta } from "/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/pages/orders/[orderId]/index.vue?macro=true";
import { default as indexk9PyE_45w79pZ8P787o7Q_oN3Nd3Dun_TAaGF7OXsiHYIMeta } from "/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/pages/checkout/shipping/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/pages/index.vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/pages/cart/index.vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexETW761_fxZ_Mp535lkVUC1hGWuKFio2DI_45EcnFxurpwMeta || {},
    component: () => import("/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/pages/terms/index.vue")
  },
  {
    name: "orders",
    path: "/orders",
    component: () => import("/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/pages/orders/index.vue")
  },
  {
    name: "product",
    path: "/product",
    component: () => import("/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/pages/product/index.vue")
  },
  {
    name: "proposals",
    path: "/proposals",
    component: () => import("/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/pages/proposals/index.vue")
  },
  {
    name: "closed-kits",
    path: "/closed-kits",
    meta: { ...(indexDIEe1fCiNQjLZFpFdda26PvOAAnTgFVGp7Io0D520VcMeta || {}), ...{"middleware":["home"]} },
    component: () => import("/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/pages/closed-kits/index.vue")
  },
  {
    name: "custom-kits",
    path: "/custom-kits",
    component: () => import("/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/pages/custom-kits/index.vue")
  },
  {
    name: "spare-products",
    path: "/spare-products",
    component: () => import("/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/pages/spare-products/index.vue")
  },
  {
    name: "checkout-confirm",
    path: "/checkout/confirm",
    meta: indexChQZVKgwxg8qQ6n2FeVqQJdxhwJXiw1SuylndDQIVVUMeta || {},
    component: () => import("/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/pages/checkout/confirm/index.vue")
  },
  {
    name: "checkout-payment",
    path: "/checkout/payment",
    meta: indext02As8mdbm0ZOLQhYKU8hXTjRkIg_45j3AgnwHfruE5Q0Meta || {},
    component: () => import("/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/pages/checkout/payment/index.vue")
  },
  {
    name: "orders-orderId",
    path: "/orders/:orderId()",
    component: () => import("/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/pages/orders/[orderId]/index.vue")
  },
  {
    name: "checkout-shipping",
    path: "/checkout/shipping",
    meta: indexk9PyE_45w79pZ8P787o7Q_oN3Nd3Dun_TAaGF7OXsiHYIMeta || {},
    component: () => import("/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/pages/checkout/shipping/index.vue")
  }
]